// extracted by mini-css-extract-plugin
export default {"root":"IconEBP_root__OW8EE"};